import HttpInterceptor from './httpInterceptor';

const baseURL = `${process.env.API_URL}:${process.env.API_PORT}/`;

export default class HTTPRequestHandler {
    static request = new HttpInterceptor(baseURL).getRequest();

    static get = (url, headers = {}) => HTTPRequestHandler.request.get(url, headers);

    static post = (url, payload, headers = {}) => HTTPRequestHandler.request.post(url, payload, headers);

    static put = (url, payload, headers = {}) => HTTPRequestHandler.request.put(url, payload, headers);

    static delete = (url, payload, headers = {}) => HTTPRequestHandler.request.delete(url, payload, headers);

    static patch = (url, payload, headers = {}) => HTTPRequestHandler.request.patch(url, payload, headers);

    static head = (url, payload, headers = {}) => HTTPRequestHandler.request.head(url, payload, headers);

    static redirectTo = (path) => {
        document.location = path;
    };
}
